import { ROUND_TO_INT } from "./index117.js";
function coinChangeCombinations(coins, amount, roundBy = ROUND_TO_INT) {
	const originalCoins = coins.slice();
	coins = coins.map((c) => Math.round(c * roundBy));
	amount = Math.round(amount * roundBy);
	const res = coins.map((coin) => ({
		coin,
		amount: 0
	}));
	const combs = [];
	f(0, amount);
	function f(index, amount$1) {
		if (amount$1 === 0) combs.push(res.map((c) => ({ ...c })));
		else if (index < coins.length) {
			const coin = coins[index];
			const count = amount$1 / coin | 0;
			if (count < 0) console.log(count);
			for (let i = 0; i <= count; i++) {
				res[index].amount = i;
				f(index + 1, amount$1 - coin * i);
				res[index].amount = 0;
			}
		}
	}
	for (const comb of combs) for (let i = 0; i < comb.length; i++) comb[i].coin = originalCoins[i];
	return combs;
}
export { coinChangeCombinations };

//# sourceMappingURL=index244.js.map